import axios from "axios";
import Cookies from "js-cookie";

const MoodleAuthApi = {
    async autenticarMoodle() {
        try {

            const tokenCookie = Cookies.get('token');
            
            if (!tokenCookie) {
                throw new Error('Token não encontrado');
            }
            const tokenObjeto = JSON.parse(tokenCookie);
            const jwt = tokenObjeto.jwt;

            if (!jwt) {
                throw new Error('JWT não encontrado no token');
            }

            // Tenta primeiro com fetch
            try {
                const response = await fetch('https://cursos.itera360.com.br/auth/jwt/login.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({ token: jwt }),
                    credentials: 'include'
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                return data;
            } catch (fetchError) {
                
                // Fallback para axios
                const response = await axios.post('https://cursos.itera360.com.br/auth/jwt/login.php', {
                    token: jwt
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    withCredentials: true
                });

                return response.data;
            }
        } catch (error) {
            throw error;
        }
    }
};

export default MoodleAuthApi; 